import React from 'react';

export default function StepX({ form, handleChange, next }) {
  const isValid = form.x.startsWith('@') && form.x.length > 1;

  return (
    <div style={{ textAlign: 'center' }}>
      <h2 style={{
        fontFamily: "'Patrick Hand', cursive",
        fontSize: '28px', fontWeight: '900', color: '#2d2d2d',
        textTransform: 'uppercase', letterSpacing: '1px',
        marginBottom: '6px'
      }}>ENTER YOUR X HANDLE</h2>

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', marginBottom: '20px' }}>
        
        <p style={{ color: '#2d2d2d', fontSize: '13px', margin: 0, fontFamily: "'Patrick Hand', cursive" }}>
          Enter your X (Twitter) username to get started
        </p>
      
      </div>

      <input
        name="x" 
        placeholder="@yourhandle"
        value={form.x} 
        onChange={(e) => {
          let value = e.target.value;
          if (value && !value.startsWith('@')) {
            value = '@' + value;
          }
          handleChange({ target: { name: 'x', value } });
        }}
        style={{
          width: '100%', padding: '16px',
          background: '#fff',
          border: '3px solid #2d2d2d',
          borderRadius: '12px',
          color: '#2d2d2d', fontSize: '16px',
          fontFamily: "'Patrick Hand', cursive",
          marginBottom: '8px', outline: 'none',
          boxSizing: 'border-box',
          boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.08)'
        }}
      />

      {/* Validation message */}
      {!isValid && form.x && (
        <p style={{ 
          color: '#d32f2f', 
          fontSize: '12px', 
          marginBottom: '16px',
          fontWeight: '600'
        }}>
          ⚠️ Username must start with @ (e.g., @username)
        </p>
      )}

      <button 
        onClick={next} 
        disabled={!isValid}
        style={{
          width: '100%', padding: '18px',
          background: isValid 
            ? 'linear-gradient(180deg, #5cb85c 0%, #4cae4c 100%)' 
            : '#8b8b8b',
          border: '3px solid #2d2d2d',
          borderRadius: '12px', color: '#fff',
          fontSize: '18px', fontWeight: '900',
          fontFamily: "'Patrick Hand', cursive",
          textTransform: 'uppercase', letterSpacing: '2px',
          cursor: isValid ? 'pointer' : 'not-allowed',
          transform: isValid ? 'skewX(-5deg)' : 'skewX(-5deg) scale(0.98)',
          boxShadow: isValid 
            ? '0 6px 0 #2d2d2d, 0 10px 20px rgba(0,0,0,0.2)' 
            : '0 2px 0 #2d2d2d',
          transition: 'all 0.1s ease',
          opacity: isValid ? 1 : 0.6,
          marginTop: '16px',
          textShadow: '1px 1px 0 rgba(0,0,0,0.2)'
        }}
        onMouseDown={(e) => {
          if (!isValid) return;
          e.target.style.transform = 'skewX(-5deg) translateY(4px)';
          e.target.style.boxShadow = '0 2px 0 #2d2d2d, 0 4px 10px rgba(0,0,0,0.2)';
        }}
        onMouseUp={(e) => {
          if (!isValid) return;
          e.target.style.transform = 'skewX(-5deg) translateY(0)';
          e.target.style.boxShadow = '0 6px 0 #2d2d2d, 0 10px 20px rgba(0,0,0,0.2)';
        }}
      >
        <span style={{ display: 'inline-block', transform: 'skewX(5deg)' }}>
          {isValid ? 'CONTINUE →' : 'ENTER VALID HANDLE'}
        </span>
      </button>
    </div>
  );
}